/**
 * UA 判断工具函数
 */

// 获取 UserAgent
export const getUserAgent = (): string => {
  return navigator.userAgent;
};

// 判断是否为 iOS
export const isIOS = (): boolean => {
  const ua = getUserAgent();
  return /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

// 判断是否为 Android
export const isAndroid = (): boolean => {
  const ua = getUserAgent();
  return /Android/.test(ua);
};

// 判断是否为 HarmonyOS
export const isHarmonyOS = (): boolean => {
  const ua = getUserAgent();
  return /OpenHarmony/i.test(ua);
};

// 判断是否为移动设备
export const isMobile = (): boolean => {
  return isIOS() || isAndroid();
};

// 判断是否为微信浏览器
export const isWeChat = (): boolean => {
  const ua = getUserAgent();
  return /MicroMessenger/i.test(ua);
};

// 判断是否为 QQ 浏览器
export const isQQ = (): boolean => {
  const ua = getUserAgent();
  return /QQ/i.test(ua);
};

// 获取 iOS 版本号
export const getIOSVersion = (): number | null => {
  if (!isIOS()) return null;

  const ua = getUserAgent();
  const match = ua.match(/OS (\d+)_(\d+)_?(\d+)?/);
  if (match) {
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = match[3] ? parseInt(match[3], 10) : 0;
    return major + minor / 10 + patch / 100;
  }
  return null;
};

// 获取 Android 版本号
export const getAndroidVersion = (): number | null => {
  if (!isAndroid()) return null;

  const ua = getUserAgent();
  const match = ua.match(/Android (\d+\.?\d*)/);
  if (match) {
    return parseFloat(match[1]);
  }
  return null;
};

// 获取设备信息
export const getDeviceInfo = () => {
  const ua = getUserAgent();

  return {
    userAgent: ua,
    isIOS: isIOS(),
    isAndroid: isAndroid(),
    isMobile: isMobile(),
    isWeChat: isWeChat(),
    isQQ: isQQ(),
    iosVersion: getIOSVersion(),
    androidVersion: getAndroidVersion(),
    platform: navigator.platform,
    language: navigator.language,
  };
};

// 判断是否为低版本 iOS（iOS 9 以下）
export const isLowVersionIOS = (): boolean => {
  const version = getIOSVersion();
  return version !== null && version < 9;
};

// 判断是否为低版本 Android（Android 4.4 以下）
export const isLowVersionAndroid = (): boolean => {
  const version = getAndroidVersion();
  return version !== null && version < 4.4;
};

// 判断是否为低版本设备
export const isLowVersionDevice = (): boolean => {
  return isLowVersionIOS() || isLowVersionAndroid();
};

// 判断是否在爱学App中
export const isAiXueApp = (): boolean => {
  const ua = getUserAgent();
  return /AI_English/i.test(ua);
};

// 获取ua中的数据
export const getValueFromUserAgent = (key: string): string | null => {
  const ua = getUserAgent();
  const match = ua.match(new RegExp(`${key}\\/([a-zA-Z0-9\\-_\\.=]+)(?=\\s|$)`)); 
  return match ? match[1] : null;
};
